import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  getSingleOrder,
  getSingleOrderStatus,
} from '../../redux/actions/delivery';

import OrderDetail from './OrderDetail.page';

const mapStateToProps = state => ({
  orderDetail: state.delivery.orderDetail,
  orderTrackStatus: state.delivery.orderTrackStatus,
  loading: state.delivery.loading,
});

const mapDispatchToProps = { getSingleOrder, getSingleOrderStatus };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(OrderDetail));
